import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "weekly-products-filter" }
const _hoisted_2 = { class: "weekly-products-filter__checkboxes" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FTSProductsFilter = _resolveComponent("FTSProductsFilter")!
  const _component_ComponentInput = _resolveComponent("ComponentInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_FTSProductsFilter, {
      modelValue: _ctx.productsAccessor,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.productsAccessor) = $event)),
      disabled: _ctx.disabled
    }, null, 8, ["modelValue", "disabled"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_ComponentInput, {
        modelValue: _ctx.productsAccessor.isProductNumber,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.productsAccessor.isProductNumber) = $event)),
        id: "product-number",
        type: "checkbox",
        label: "Номер товара",
        mod: "checkbox-green",
        disabled: _ctx.disabled
      }, null, 8, ["modelValue", "disabled"]),
      _createVNode(_component_ComponentInput, {
        modelValue: _ctx.productsAccessor.isProductDescription,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.productsAccessor.isProductDescription) = $event)),
        id: "product-description",
        type: "checkbox",
        label: "Описание товара",
        mod: "checkbox-green",
        disabled: _ctx.disabled
      }, null, 8, ["modelValue", "disabled"]),
      _createVNode(_component_ComponentInput, {
        modelValue: _ctx.productsAccessor.isAdditionalProductDescription,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.productsAccessor.isAdditionalProductDescription) = $event)),
        id: "additional-product-description",
        type: "checkbox",
        label: "Доп. описание товара",
        mod: "checkbox-green",
        disabled: _ctx.disabled
      }, null, 8, ["modelValue", "disabled"])
    ])
  ]))
}